import React, { useState } from "react";
import { gsap } from "gsap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";
import { getAllMovies } from "../../../firebase";
import "../home/css/style.css";

const RelatedMovies = (genre) => {
  const [moviedata, setMoviedata] = useState([]);

  React.useEffect(() => {
    getAllMovies()
      .then((data) => {
        const PropData = [];
        data.forEach((doc) => {
          PropData.push(doc.data());
        });
        console.log(genre);
        console.log("PropData", PropData);
        /* fetch moviesby genre */
        const moviesbygenre = PropData.filter((item) => {
          return item.genres === genre;
        });
        setMoviedata(PropData);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  }, []);

  const [swiper, setSwiper] = useState(null);

  const slideNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const slidePrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  const slideTo = (index) => {
    if (swiper !== null) {
      swiper.slideTo(index);
    }
  };

  const onSwiper = (swiper) => {
    setSwiper(swiper);
  };

  return (
    <React.Fragment>
      <Container fluid>
        <Row>
          <Col sm="12" className="overflow-hidden">
            <div className="d-flex align-items-center justify-content-between">
              <h4 className="related-movies-title">Related Movies</h4>
              <Link
                className="related-movies-view"
                to="/movies"
                style={{ fontWeight: "400" }}
              >
                View All
              </Link>
            </div>
            <div id="favorites-contens">
              <div id="prev" className="swiper-button swiper-button-prev">
                <i className="fa fa-chevron-left"></i>
              </div>
              <div id="next" className="swiper-button swiper-button-next">
                <i className="fa fa-chevron-right"></i>
              </div>
              <Swiper
                navigation={{
                  prevEl: "#prev",
                  nextEl: "#next",
                }}
                breakpoints={{
                  320: { slidesPerView: 2 },
                  550: { slidesPerView: 3 },
                  991: { slidesPerView: 5 },
                  1400: { slidesPerView: 6 },
                }}
                loop={true}
                slidesPerView={4}
                spaceBetween={20}
                as="ul"
                className="favorites-slider list-inline  row p-0 m-0 iq-rtl-direction"
              >
                {moviedata.map((data, index) => (
                  <SwiperSlide key={data.id} as="li">
                    <div className="block-images position-relative">
                      <div className="movie-thumb-new">
                        <img
                          src={data.thumbnail}
                          className="img-fluid"
                          alt=""
                        />
                      </div>
                      <div className="block-description">
                        <h6 className="iq-title p-1">
                          <Link to="/show-details">{data.movie_title}</Link>
                        </h6>
                        <div
                          className="movie-time d-flex align-items-center my-2 iq-ltr-direction"
                          style={{ fontSize: "19px", opacity: "0.7" }}
                        >
                          <span
                            className="badge badge-secondary p-1"
                            style={{
                              backgroundColor: "#fff0",
                            }}
                          >
                            {data.genres}
                          </span>
                        </div>
                        <div className="hover-buttons p-1">
                          <a
                            href={`/movie/${data.slug}`}
                            role="button"
                            className="header-cta"
                            style={{
                              fontWeight: 500,
                              color: "#fff",
                              padding: "25px 15px",
                              borderRadius: ".3rem",
                            }}
                          >
                            View
                          </a>
                        </div>
                      </div>
                      <div className="block-social-info">
                        <ul className="list-inline p-0 m-0 music-play-lists">
                          <li className="share">
                            <span>
                              <i className="ri-share-fill"></i>
                            </span>
                            <div className="share-box">
                              <div className="d-flex align-items-center">
                                <Link
                                  to={
                                    "//www.facebook.com/sharer?u=" +
                                    window.location.href
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="share-ico"
                                  tabIndex="0"
                                >
                                  <i className="ri-facebook-fill"></i>
                                </Link>
                                <Link
                                  to={
                                    "//twitter.com/intent/tweet?text=" +
                                    window.location.href
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="share-ico"
                                  tabIndex="0"
                                >
                                  <i className="ri-twitter-fill"></i>
                                </Link>
                                <Link
                                  to="#"
                                  data-link="https://iqonic.design/wp-themes/streamit_wp/movie/shadow/"
                                  className="share-ico iq-copy-link"
                                  tabIndex="0"
                                >
                                  <i className="ri-links-fill"></i>
                                </Link>
                              </div>
                            </div>
                          </li>
                          {/* <li>
                                             <span><i className="ri-heart-fill"></i></span>
                                             <span className="count-box">19+</span>
                                          </li>
                                          <li>
                                             <span><i className="ri-add-line"></i></span>
                                </li> */}
                        </ul>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default RelatedMovies;
